export default class FormNewsletter {
  nome: string = "";
  cognome: string = "";
  email: string = "";
  accettazione_privacy?: boolean = false;
  recaptcha?: string = "";
}
